import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useState } from "react";
import styled from "styled-components";
import { IComponent } from "../Component";

export const YOUTUBE_COMPONENT = "youtube";
export interface YouTubeSpec {
  type: typeof YOUTUBE_COMPONENT;
  youtubeUrl: string;
  size: "small" | "medium" | "large";
}

export const YouTubeContainer = styled.div<{
  size: "small" | "medium" | "large";
}>`
  display: block;
  margin-top: 15px;
  max-width: ${(props) => {
    switch (props.size) {
      case "small":
        return "400px";
      case "medium":
        return "560px";
      case "large":
        return "800px";
      default:
        return "560px";
    }
  }};
  width: 100%;
  
  .video-container {
    position: relative;
    padding-bottom: 56.25%; /* 16:9 aspect ratio */
    height: 0;
    overflow: hidden;
  }
  
  .video-container iframe {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export const YouTubePlaceholder = styled.div`
  border: 2px dashed #888;
  border-radius: 15px;
  background: white;
  width: 200px;
  height: 200px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #888;
`;

const getYouTubeEmbedUrl = (url: string): string => {
  // Extract video ID from YouTube URL
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
  const match = url.match(regExp);
  
  if (match && match[2].length === 11) {
    // Return YouTube nocookie embed URL
    return `https://www.youtube-nocookie.com/embed/${match[2]}`;
  }
  
  return "";
};

const Component = (props: { spec: YouTubeSpec }) => {
  const [error, setError] = useState<string | null>(null);
  
  if (error) {
    return (
      <YouTubePlaceholder>
        <div>
          <div>
            <FontAwesomeIcon
              icon={faTimes}
              size="3x"
              style={{ marginBottom: "10px" }}
            />
          </div>
          <div>Es ist ein Fehler beim Laden des Videos aufgetreten</div>
        </div>
      </YouTubePlaceholder>
    );
  }

  if (!props.spec.youtubeUrl) {
    return <h1>Keine YouTube-URL angegeben</h1>;
  }
  
  const embedUrl = getYouTubeEmbedUrl(props.spec.youtubeUrl);
  
  if (!embedUrl) {
    return <h1>Ungültige YouTube-URL</h1>;
  }

  return (
    <YouTubeContainer size={props.spec.size || "medium"}>
      <div className="video-container">
        <iframe 
          src={embedUrl}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        ></iframe>
      </div>
    </YouTubeContainer>
  );
};

export const YouTubeComponent: IComponent<YouTubeSpec> = {
  component: Component,
};
